export default __webpack_public_path__ + "static/media/logoAnimatedWhite.d28bf929.gif";